<template>
  <module-content/>
</template>

<script>
	import moduleContent from '../text-editor/module-content'

	export default {
		data () {
			return {}
		},
		mounted () {
		},
		components: {
			moduleContent
		},
		watch: {},
		computed: {},
		methods: {}
	}
</script>
<style scoped lang="scss">
</style>
